import Cube from './Cube'
import Report from './Report'
import Redux from './Redux'

export default {
  Cube,
  Report,
  Redux,
}
